import { supabase } from "@/lib/supabase";

type ProductLike = {
  category?: string;
  categories?: string[];
  video_url?: string;
};

export const DEFAULT_CATEGORY_OPTIONS = [
  "Todos",
  "Alimentício",
  "Metalúrgico",
  "Têxtil",
  "Automobilístico",
  "Higiene Pessoal",
  "Automação",
];

export const getProductCategories = (product: Partial<ProductLike>) => {
  const categories = product.categories?.filter(Boolean) ?? [];

  if (categories.length > 0) {
    return categories;
  }

  return product.category ? [product.category] : [];
};

export const mergeCategoryOptions = (
  lists: Array<Array<string | undefined>>,
  includeAll = false
) => {
  const names = lists
    .flat()
    .filter((name): name is string => Boolean(name?.trim()));

  const options = Array.from(new Set(names));

  return includeAll ? ["Todos", ...options.filter((name) => name !== "Todos")] : options;
};

export const fetchCategoryNames = async () => {
  const { data, error } = await supabase.from("categories").select("name").order("name");

  if (error) {
    console.error(error);
    return [];
  }

  return data?.map((category) => category.name).filter(Boolean) ?? [];
};

export const getVideoEmbedUrl = (url?: string) => {
  if (!url?.trim()) return "";

  try {
    const parsed = new URL(url.trim());
    const host = parsed.hostname.replace(/^www\./, "");

    if (host === "youtu.be") {
      const id = parsed.pathname.split("/").filter(Boolean)[0];
      return id ? `https://www.youtube.com/embed/${id}` : "";
    }

    if (host.includes("youtube.com")) {
      const id =
        parsed.searchParams.get("v") ||
        parsed.pathname.match(/\/(shorts|embed)\/([^/?]+)/)?.[2];

      return id ? `https://www.youtube.com/embed/${id}` : "";
    }

    if (host.includes("vimeo.com")) {
      const id = parsed.pathname.split("/").filter(Boolean).pop();
      return id ? `https://player.vimeo.com/video/${id}` : "";
    }

    if (host.includes("drive.google.com")) {
      const id =
        parsed.pathname.match(/\/file\/d\/([^/]+)/)?.[1] ||
        parsed.searchParams.get("id");

      return id ? `https://drive.google.com/file/d/${id}/preview` : "";
    }
  } catch (err) {
    console.error(err);
  }

  return "";
};
